import dayjs from "dayjs";

export const isInThePast = (date: string) => {
  const now = new Date();
  const nowDate = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
  return dayjs(date).isBefore(nowDate, "day");
};

export const getDateRange = (
  startDate: string,
  endDate?: string,
  format?: string
) => {
  const dateFormat = format || "D MMM YYYY";
  const [dayPart, monthPart, yearPart] = dateFormat.split(" ");

  // Does endDate exist?
  if (!endDate) {
    return dayjs(startDate).format(dateFormat);
  }
  // Is endDate before startDate?
  if (dayjs(endDate).isBefore(dayjs(startDate), "day")) {
    return dayjs(startDate).format(dateFormat);
  }
  // Is startDate and endDate the same?
  if (dayjs(startDate).isSame(dayjs(endDate), "day")) {
    return dayjs(startDate).format(dateFormat);
  }
  // Is startDate and endDate in the same month?
  if (dayjs(startDate).isSame(dayjs(endDate), "month")) {
    return `${dayjs(startDate).format(dayPart)} - ${dayjs(endDate).format(
      dateFormat
    )}`;
  }
  // Is startDate and endDate in the same year?
  const shortMonth = `${dayPart} MMM`;
  if (dayjs(startDate).isSame(dayjs(endDate), "year")) {
    return `${dayjs(startDate).format(shortMonth)} - ${dayjs(endDate).format(
      `${shortMonth} ${yearPart}`
    )}`;
  }
  // Start and end date are in different years
  return `${dayjs(startDate).format(`${shortMonth} ${yearPart}`)} - ${dayjs(
    endDate
  ).format(`${shortMonth} ${yearPart}`)}`;
};
